import { createRoute } from '@tanstack/react-router'
import { CollectionDetailsPage } from '@/features/collections/pages/CollectionDetailsPage'
import { Route as collectionsRoute } from '../collections'

export const Route = createRoute({
  getParentRoute: () => collectionsRoute,
  path: '/$id',
  component: CollectionDetailsPage,
})
